/// <amd-module name="Build/Admin/Pool/Stores/ElasticPoolLogStore" />
import { Store } from "VSS/Reflux/Store";

import { ElasticPoolLog } from "DistributedTask/Client/Contracts/TaskAgent";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IElasticPoolLogStoreState {
    elasticPoolLogs: ElasticPoolLog[];
    status: StoreStatus;
}

export class ElasticPoolLogStore extends Store {
    public state: IElasticPoolLogStoreState = {
        elasticPoolLogs: [],
        status: StoreStatus.None
    };

    constructor() {
        super("ElasticPoolLogStoreChanged");
    }

    public updateElasticPoolLogs = (elasticPoolLogs: ElasticPoolLog[]) => {
        this.state = {
            elasticPoolLogs,
            status: StoreStatus.Loaded
        };
        this.emitChanged();
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            ...this.state,
            status
        };
        this.emitChanged();
    }
}
